import React, { useEffect, useState } from "react";

interface IProps {
  toTime: Date;
  hours?: boolean;
}

const Countdown = ({
  toTime,
  hours
}: IProps) => {
  const [timeLeft, setTimeLeft] = useState<number>(toTime.getTime() - Date.now());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(toTime.getTime() - Date.now());
    }, 1000);
    return () => clearTimeout(timer);
  });

  return <>
    {hours && <>{Math.max(Math.floor(timeLeft / (60 * 60000)), 0).toString(10).padStart(2, "0")}:</>}
    {Math.floor((timeLeft - ((Math.max(Math.floor(timeLeft / (60 * 60000)), 0)) * 60 * 60000)) / 60000).toString(10).padStart(2, "0")}
    :{Math.floor((timeLeft - (Math.floor(timeLeft / 60000) * 60000)) / 1000).toString(10).padStart(2, "0")}
  </>
}

export default Countdown;
